import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';
import styles from './styles.css';

const FormLayout = ({ title, className, children }) => (
  <section className={cn(className, styles.container, 'flex')}>
    <div className={styles.title}>
      <h4 className="f5 mr3">{title}</h4>
    </div>
    <Card className={`pa3 flex-grow-1`}>{children}</Card>
  </section>
);

export default FormLayout;



// WEBPACK FOOTER //
// ./src/components/formLayout/formLayout.jsx